import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";

Vue.use(Vuetify, {
  iconfont: "md",

  theme: {
    primary: "#2f5578",
    secondary: "#00c2f3",
    accent: "#7986CB",
    error: "#f44336",
    warning: "#44d9ff",
    info: "#2196f3",
    success: "#4caf50"
  }
});
